"use strict";
function basePropertyOf(object) {
    return function (key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = basePropertyOf;
//# sourceMappingURL=_basePropertyOf.js.map